export default "__VITE_ASSET__BeFF5C7i__"